import { render, staticRenderFns } from "./PickupPoint.vue?vue&type=template&id=89a52290&scoped=true&"
import script from "./PickupPoint.vue?vue&type=script&lang=js&"
export * from "./PickupPoint.vue?vue&type=script&lang=js&"
import style0 from "./PickupPoint.vue?vue&type=style&index=0&id=89a52290&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a52290",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
installComponents(component, {VHover})
